import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BaseDialogComponent } from '@helpers/base';

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm.dialog.html',
    styleUrls: ['./dialog.scss'],
    standalone: true,
    imports: [MatToolbarModule, MatDialogModule, MatButtonModule, MatIconModule, NgFor, TranslateModule],
})
export class ConfirmDialog extends BaseDialogComponent {
    public title: string;
    public message: string;

    primaryButton: { label: string; value: any };
    secondaryButtons: { label: string; value: any }[];

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        super(dialogRef);

        this.primaryButton = this.data.buttons.pop();
        this.secondaryButtons = this.data.buttons;
    }
}
